import { TaskCreationParams, TaskStatus, TaskUpdateParams } from 'chaika-frontend-types/frontend-cms';

import { authUserService } from '@store/AuthUser/services/authUserService';
import { store } from '@store';

import { taskStore } from '@store/Task';

// ВРЕМЕННЫЙ МОСТ MobX. RQ-функции директории чистые; это единственное место, где common/Task пишет в MobX
// (taskStore.taskList) — чтобы внешние читатели, ещё не переехавшие на RQ, видели изменения из right-menu.
//
// Удалить этот файл целиком, когда на RQ переедут ВСЕ внешние потребители taskStore.taskList:
//   - dashboard/ui/pages/TasksPage: hooks/useTasksData, TaskTable/hooks/useColumns
//   - patient/ui/EhrPage/pages/TreatmentPlanPage: Tabs/TaskTab/hooks/useTasksData, TabBarItems/TasksItem
//   - patient/ui/SoapEntryPage: SystemBlock/Tasks/hooks/useTasks, Tasks/components/TaskCard, hooks/useMedicalCaseServerEvents
//   - patient/services/entry: entryMedicalCaseService, medicalCaseDetachment, EntryPrintFormParamsHelper

export function syncCreatedTaskToStore(params: TaskCreationParams): void {
    taskStore.taskList.add([
        {
            ...params,
            executorIds: params.executorIds ?? [],
            practiceIds: params.practiceIds ?? [],
            timezone: params.timezone ?? authUserService.getTimezone(),
            authorId: store.authUser.id,
            createdAt: new Date().toISOString(),
            status: TaskStatus.Requested,
        },
    ]);
}

export function syncTaskUpdateToStore(id: string, params: TaskUpdateParams): void {
    taskStore.taskList.update(id, params);
}

export function syncTaskStatusToStore(id: string, status: TaskStatus): void {
    taskStore.taskList.update(id, { status });
}

export function syncTaskCompletedToStore(id: string): void {
    taskStore.taskList.update(id, { status: TaskStatus.Completed, actualExecutorId: store.authUser.id });
}
